import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '../types/User'; // Update this path to match your project structure

// Define the initial state interface
interface UserState {
    user: User | null; // User is either null or adheres to the User interface
}

// Define the initial state
const initialState: UserState = {
    user: null,
};

// Create the user slice
const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        // Set the user data in the Redux store
        setUser(state, action: PayloadAction<User>) {
            state.user = action.payload;
        },
        removeUser(state) {
            state.user = null;
        },
        // Update specific user properties while keeping the rest intact
        updateUser(state, action: PayloadAction<Partial<User>>) {
            if (state.user) {
                state.user = { ...state.user, ...action.payload };
            }
        },
    },
});

// Export the actions
export const {
    setUser,
    removeUser,
    updateUser
} = userSlice.actions;

// Selector to get user timezone from state
// Falls back to browser timezone if user timezone is not set
export const selectUserTimezone = (state: { user: UserState }): string => {
    const userTimezone = state.user.user?.settings?.timeZone;
    if (userTimezone) {
        return userTimezone;
    }
    // Fallback to browser timezone
    return typeof Intl !== 'undefined' && Intl.DateTimeFormat
        ? Intl.DateTimeFormat().resolvedOptions().timeZone
        : 'UTC';
};

// Export the reducer to be included in the Redux store
export default userSlice.reducer;
